import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appEventFence]'
})
export class EventFenceDirective {

  constructor() {
  }

  @HostListener('click', ['$event', '$event.target'])
  onClick(event: MouseEvent) {
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
}
